/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function shallowEquals(array1, array2) {
    if (!array1 || !array2) return false;
    if (typeof array1 !== "object" || typeof array2 !== "object") return false;
    if (array1.constructor !== Array || array2.constructor !== Array) return false;
    if (array1.length !== array2.length) return false;

    for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) return false;
    }

    return true;
}
